import { Box, Typography } from '@mui/material'
import Summary from 'components/summary/summary'
import { useMappedTranslation } from 'hooks'

import { AutomationTagIds } from '../../../../assets/test/test-automation-tag-id'
import IconPrivacy from '../assets/images/privacy.svg'

const PrivacySummary = () => {
  const t = useMappedTranslation()

  return (
    <Summary
      size={'small'}
      pageUrl={'/dashboard/privacy'}
      isLoading={false}
      titleIcon={IconPrivacy}
      title={t('privacy.title')}
      content={
        <Box sx={{ pt: { xs: '8px', md: '0' }, width: '100%' }} data-testid={AutomationTagIds['cards.dashboard-privacy-notice']}>
          <Typography variant='body1'>{t('privacy.summary')}</Typography>
        </Box>
      }
    />
  )
}

export default PrivacySummary
